import { useState } from "react";

export const WithState = ({ initialState, children }) => {
  const [state, setState] = useState(initialState);
  return children(state, setState);
};